<template>
  <div class="container lang-dir">
    <p>{{ name }}</p>
    <div
      class="flex"
      style="font-size: 11px; justify-content: space-between; color: #7b7b7b"
    >
      <p>{{ books.toLocaleString() }} {{ $t("general.books") }}</p>
      <p class="open-list" @click="$emit('openList')">
        {{ $t("lists.openList") }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["name", "books"],
};
</script>

<style lang="scss" scoped>
.container {
  padding: 8px 0px;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  overflow-x: hidden;
}
p {
  margin: 0px;
}
.open-list {
  color: rgba(0, 0, 0, 0.7);
  font-size: 9px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.05);
  padding: 2px 5px;
  cursor: pointer;
}
</style>
